import { render, staticRenderFns } from "./SendEmailPurchasesCsvModal.vue?vue&type=template&id=72f78855"
import script from "./SendEmailPurchasesCsvModal.vue?vue&type=script&lang=js"
export * from "./SendEmailPurchasesCsvModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports